export const resolveId = (obj) => {
    if (obj === null || obj === void 0 ? void 0 : obj.id) {
        return obj.id;
    }
    if (obj === null || obj === void 0 ? void 0 : obj._id) {
        console.log('[Wix Blog]', 'No "id" field found', obj);
        return obj._id;
    }
    if (obj === null || obj === void 0 ? void 0 : obj.internalId) {
        return obj.internalId;
    }
    return undefined;
};
/**
 * Kept for backwards compatibility
 *
 * @deprecated
 */
export const resolveLegacyId = (obj) => { var _a; return (_a = obj === null || obj === void 0 ? void 0 : obj._id) !== null && _a !== void 0 ? _a : obj === null || obj === void 0 ? void 0 : obj.internalId; };
//# sourceMappingURL=resolve-id.js.map